import { ControlValueAccessor, Validator, FormControl} from '@angular/forms';
import { FormConstants } from '../../core/globals/form-constants';

export class BaseControlValueAccessor<T> implements ControlValueAccessor {


  public value: T;
  public disabled = false;
  public errorMessages = FormConstants.errorMessages;

  // Call when value has changed programmatically
  public onChange(newVal: T) {}

  public onTouched(_?: any) {}

  // Model -> View changes
  public writeValue(obj: T): void {
    this.value = obj;
  }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  public setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  public getErrorMessage(formControl: FormControl) {
    const errorKey = Object.keys(formControl.errors)[0];
    switch (errorKey) {
      case 'required': return this.errorMessages.required;
      case 'email': return this.errorMessages.email;
      case 'pattern': return this.errorMessages.pattern;
      case 'phone': return this.errorMessages.phone;
      case 'minlength' : return this.errorMessages.minlength;
      case 'etsMobileMandate' : return this.errorMessages.etsMobileMandate;
      case 'payerReq' : return this.errorMessages.payerReq;
      default: return this.errorMessages.pattern;
    }
  }
}
